import React from 'react';
import { FlexGrid, getRehydratableName, getClassNameFactory } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import FrequentlyAskedQuestionItem from './components/FrequentlyAskedQuestionItem';
import {
  IFrequentlyAskedQuestionProps,
  IFrequentlyAskedQuestionsProps,
} from './FrequentlyAskedQuestionsTypes';
import './index.css';

export const FrequentlyAskedQuestions = (
  props: IFrequentlyAskedQuestionsProps
): React.ReactElement => {
  const { questionsList } = props;
  const getClassName = getClassNameFactory(
    FrequentlyAskedQuestions.displayName
  );
  return (
    <div
      data-rehydratable={getRehydratableName(
        FrequentlyAskedQuestions.displayName
      )}
      {...propsToDataAttributes(props)}
      className={getClassName({ descendantName: 'wrapper' })}
    >
      <FlexGrid>
        <FlexGrid.Row className={getClassName({ descendantName: 'content' })}>
          {questionsList?.map(
            (
              { title, link, description }: IFrequentlyAskedQuestionProps,
              idx: number
            ) => {
              const keyValue = `title_${idx + 1}`;
              return (
                <FrequentlyAskedQuestionItem
                  key={keyValue}
                  title={title}
                  link={link}
                  description={description}
                />
              );
            }
          )}
        </FlexGrid.Row>
      </FlexGrid>
    </div>
  );
};

FrequentlyAskedQuestions.displayName = 'FrequentlyAskedQuestions';
